import { withInstall } from '@zoryn/utils'
import Tag from './src/tag.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZTag: SFCWithInstall<typeof Tag> = withInstall(Tag)
export default ZTag

export * from './src/tag'
